import { useEffect, useRef, useState } from "react"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { ServerRequestProtected, ServerRequestPublic } from "../../../../utils/ServerDataRequest"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { useSelector } from "react-redux"
import { isNull } from "lodash"
import Loader from "../../../shared/Loader/Loader"
import { format } from "date-fns"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import { FindFirstChild } from "../../../../utils/FindMenuOption"
const AddNewDocument = (props) => {
    const API_URL = enumUtil.controller.General
    const API_URL_Caregiver = enumUtil.controller.CareGiver
    let IsEditAllowed = FindFirstChild('CareGiver', 'Documents')?.IsAdd

    let PateintIDR = useSelector(state => state.Open_Caregiver_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let { CaregiverDocumentID, setIsClose, onCancel } = { ...props }
    const [isLoading, setIsLoading] = useState(false)
    const fileInputRef = useRef(null);
    let Document_Modal = {
        CaregiverID: PateintIDR + "",
        DocumentTypeID: '',

        File: '',
        FileName: '',
        DocumentType: '',
        Provider: '',
        Source: '',
        Title: '',
        DocumentDateType: format(new Date(), 'MM/dd/yyy'),
        Description: '',
        ReferedBy: '',
    }
    let valModal = {}
    let ValidationModal = {
        FileNameVal: '',
        DocumentTypeVal: '',
        FileVal: '',
    }
    const [DocumetValidationModal, setDocumetValidationModal] = useState(ValidationModal)
    const [DocumetSaveUpdateModal, setDocumetSaveUpdateModal] = useState({})
    const [mainDocumetModal, setmainDocumetModal] = useState(Document_Modal);
    const [DocumentID, setDocumentID] = useState('');
    const [is, setIs] = useState(false);
    const [file, setfile] = useState()
    const handleDocumentChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainDocumetModal };
        let saveModal = { ...DocumetSaveUpdateModal }
        modal[name] = value
        setmainDocumetModal(modal)
        for (var property in Document_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setDocumetSaveUpdateModal(saveModal)
    }
    const DocuumentValidation = async () => {
        let ValidationModal = {
            FileNameVal: FormValidator(
                mainDocumetModal.FileName,
                enumUtil.enumValidationType.Required,
                'File Name',
            ),
            DocumentTypeVal: FormValidator(
                mainDocumetModal.DocumentTypeID,
                enumUtil.enumValidationType.Required,
                'Document Type',
            ),
            // FileVal: FormValidator(
            //     file,
            //     enumUtil.enumValidationType.Required,
            //     'File',
            // ),
        }
        await setDocumetValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveDocument = async () => {
        if (IsEditAllowed) {
            await DocuumentValidation()
            let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
            if (validation) {
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                let data = { ...DocumetSaveUpdateModal };
                const formData = new FormData();
                formData.append('TableName', enumUtil.enumAPITableName.CaregiverDocument);
                formData.append('ID', DocumentID);
                formData.append('data[CareGiverID]', PateintIDR + "");
                if (!isNull(file)) {
                    formData.append('File', file);
                }
                for (var key in data) {
                    formData.append(`data[${key}]`, data[key]);
                }
                ////////
                setIsLoading(true)
                ServerRequestPublic(API_URL_Caregiver + "/SaveCareGiverDocuments", 'post', formData, "Upload").then((response) => {
                    if (!isNull(response.id)) {
                        setIsClose((Math.random()))
                        setIsLoading(false)
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setDocumentID(response.id)
                        handleCancelDocument();
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            }
        }
    }
    const savefile = (e) => {
        setfile(e.target.files[0]);
        DocumetSaveUpdateModal['FileName'] = e.target.files[0].name;
        mainDocumetModal['FileName'] = e.target.files[0].name;
    }
    const removeFile = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        setfile(null);
        DocumetSaveUpdateModal['FileName'] = ''
        mainDocumetModal['FileName'] = ''
    }
    useEffect(() => {
        setmainDocumetModal(Document_Modal)
        if (CaregiverDocumentID != '0') {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "TableName": enumUtil.enumAPITableName.CaregiverDocument,
                "ID": CaregiverDocumentID + ""
            }).then((response) => {
                setIsLoading(false)
                setmainDocumetModal(response)
                setfile(response.file)
                // setDocumentData(response.Rows)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
        }
        if (!isNull(CaregiverDocumentID)) {
            setDocumentID(CaregiverDocumentID)
        }
    }, [CaregiverDocumentID])
    const handleCancelDocument = () => {
        setDocumentID('0')
        setmainDocumetModal(Document_Modal)
        removeFile();
        setDocumetSaveUpdateModal({})
        setfile(null)
        onCancel();
    }
    const handleSelectedData = (selectedData, name, type) => {

        let modal = { ...mainDocumetModal };
        if (type === 'client' && !isNull(selectedData)) {
            console.log(selectedData, name, type);
            if (name === 'DocumentTypeID') {
                modal[name] = selectedData.display
                DocumetSaveUpdateModal[name] = selectedData.code + "";
                DocumetSaveUpdateModal['DocumentTypeID'] = selectedData.value + "";
            }
            else if (name === 'BillingDocumentStatus') {
                modal[name] = selectedData.display
                DocumetSaveUpdateModal[name] = selectedData.value;
            }

        }
        else {
            modal[name] = ''
            DocumetSaveUpdateModal[name] = ''
        }
        setmainDocumetModal(modal)

        return selectedData
    }

    return (
        <>
            {isLoading ? <Loader /> : null}
            <div className="upload-box__filePicker">
                {/* {DocumetValidationModal.FileVal} */}
                {mainDocumetModal.FileName ? (
                    <div className="upload-box__filePicker__fileInfo mt-1 d-flex align-items-center">
                        <p className='mb-0 heading' title={mainDocumetModal.FileName}>{mainDocumetModal.FileName}</p>
                        <i className='icon-delete' onClick={removeFile}>
                        </i>
                        <div className="btn-Container">
                            {/* {/ <button className="btn btn-sm text-success"  onClick={savefile}>Change</button> /}
                        {/ <button className="btn btn-sm text-danger" onClick={removeFile}>Remove</button> /} */}
                        </div>
                    </div>
                ) : (
                    <div className='upload-box__filePicker__Btn'>
                        <input
                            type="file"
                            className="inputfile"
                            id="File"
                            name="File"
                            accept=".png, .txt, .pdf, .tiff"
                            onChange={savefile}
                            ref={fileInputRef}
                        // accept=".jpg, .pdf "
                        //  accept="image/*,application/pdf,text/plain" 
                        />
                        <i className="icon-link"></i>
                        <label htmlFor="file">Upload a File<span className='req'>*</span></label>
                    </div>
                )}
                <div className="upload-box__filePicker__form">
                    <div className={DocumetValidationModal.FileNameVal ? 'form-group input error' : 'form-group input'}>
                        <label htmlFor="FileName">File Name <span className='req'>*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            id="FileName"
                            name="FileName"
                            value={mainDocumetModal.FileName}
                            onChange={handleDocumentChange}
                        />
                        {DocumetValidationModal.FileNameVal}
                    </div>
                    <div className={DocumetValidationModal.DocumentTypeVal ? 'form-group input error  ar_palceholder' : 'form-group input  ar_palceholder'}>
                        <label htmlFor="DocumentTypeID">Document Type<span className='req'>*</span></label>
                        {/* <select 
                            id='DocumentTypeID' 
                            name='DocumentTypeID' 
                            value={mainDocumetModal.DocumentTypeID} 
                            className="form-control"
                            onChange={handleDocumentChange} >
                            {DropDowns?.DocumentType?.map((e, index) => (
                                <option value={e.value} key={index}>
                                    {e.display}
                                </option>
                            ))}
                        </select> */}
                        <SuperSearchList
                            type="client"
                            id='DocumentTypeID'
                            name='DocumentTypeID'
                            searchValue={mainDocumetModal.DocumentTypeID}
                            data={DropDowns?.DocumentType}
                            onChange={handleDocumentChange}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            inputError={DocumetValidationModal.DocumentTypeVal}
                        />
                        {DocumetValidationModal.DocumentTypeVal}
                        {/* <input
                            type="text"
                            className="form-control"
                            id="DocumentTypeID"
                            name="DocumentTypeID"
                            value={mainDocumetModal.DocumentTypeID}
                            onChange={handleDocumentChange}
                        />  */}
                    </div>
                    {/* <div className="form-group">
                        <label htmlFor="Provider">Provider</label>
                        <input
                            type="text"
                            className="form-control"
                            id="Provider"
                            name='Provider'
                            value={mainDocumetModal.Provider}
                        // onChange={handleDocumentChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="Source">Source</label>
                        <input
                            type="text"
                            className="form-control"
                            id="Source"
                            name="Source"
                            value={mainDocumetModal.Source}
                        // onChange={handleDocumentChange}
                        />
                    </div> */}
                    <div className="form-group input">
                        <label htmlFor="Title">Title</label>
                        <input
                            type="text"
                            className="form-control"
                            id="Title"
                            name="Title"
                            value={mainDocumetModal.Title}
                            onChange={handleDocumentChange}
                        />
                    </div>
                    {/* <div className="form-group">
                        <label htmlFor="documentDateType">Document Date Type</label>
                        <input
                            type="text"
                            className="form-control"
                            id="DocumentDateType"
                            name="DocumentDateType"
                            value={mainDocumetModal.DocumentDateType}
                            onChange={handleDocumentChange}
                        />
                    </div> */}
                    <div className="form-group input">
                        <label htmlFor="Description">Description</label>
                        <textarea
                            className="form-control doc-textarea"
                            id="Description"
                            name="Description"
                            value={mainDocumetModal.Description}
                            onChange={handleDocumentChange}
                            rows="3"
                        ></textarea>
                    </div>
                    {/* <div className="form-group">
                        <label htmlFor="referredby">Referred by</label>
                        <input
                            type="text"
                            className="form-control"
                            id="ReferedBy"
                            name="ReferedBy"
                            value={mainDocumetModal.ReferedBy}
                            onChange={handleDocumentChange}
                        />
                    </div> */}
                </div>
            </div>
            <div className='br-bottom-1 br-clr position-absolute bottom-0 w-100'>
                <div className="btns-group text-end px-3 br-top-1 br-clr d-flex align-items-center justify-content-end gap-2">
                    <button className="btn m-0 my-1 btn-gray" onClick={handleCancelDocument}>Cancel</button>
                    <button className={IsEditAllowed ? "btn m-0 my-1 btn-orange" : "btn m-0 my-1 btn-orange disabled"} onClick={handleSaveDocument}>Save</button>
                </div>
            </div>
        </>
    )
}

export default AddNewDocument